import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  websiteContentIcon,
  adCopyContentIcon,
  socialMediaContentIcon,
  personalBrandingContentIcon,
  podcastContentICon,
} from "../../../../assets/icons/serviceIcon/index";
import SeoBlogWritingWork from "./SeoBlogWritingWork";

const items = [
  {
    name: "Keyword Research & Content Planning",
    text: "Find the right keywords, map out topics, and create a blog calendar that aligns with what your audience is already searching for",
  },
  {
    name: "On-Page SEO Optimisation",
    text: "Structure your blog for success — from meta tags to internal links, everything is optimised for both search engines and real readers",
  },
  {
    name: "Off-Page SEO Optimization",
    text: "Promote your blog through smart backlinks, directory submissions, and shareable content strategies that help grow authority and build traffic over time",
  },
];

const otherService = [
  {
    icon: websiteContentIcon,
    name: "Website Content",
    des: "Make your website speak your value in the simplest way",
    path: "/website-content",
  },
  {
    icon: adCopyContentIcon,
    name: "Ad Copy & Sales Funnels",
    des: 'Clear words that guide people from curiosity to clicking "yes"',
    path: "/ad-copy-and-sale-funnels",
  },
  {
    icon: socialMediaContentIcon,
    name: "Social Media Strategy",
    des: "Plan smart, scroll-worthy posts that actually speak to your audience",
    path: "/social-media-strategy",
  },
  {
    icon: personalBrandingContentIcon,
    name: "Personal Branding Content",
    des: "Bring your voice to life across everything your audience sees",
    path: "/personal-branding-content",
  },
  {
    icon: podcastContentICon,
    name: "Podcast Scripting & Editing",
    des: "Turn your ideas into podcasts that engage with your audience",
    path: "/podcast-scripting-and-editing",
  },
];
const SeoBlogWriting = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Writing"
        description="We create blog content that’s easy to read, built to rank, and made to attract the right audience, helping your website grow steadily with value-packed blogs people enjoy reading."
        heading="Seo Blog"
      />
      <NewCommonServiceForm title="Seo Blog Writing" items={items} />
      <SeoBlogWritingWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default SeoBlogWriting;
